import closeButton from "@/icons/x-button.svg";

const CloseButton = ({ handler }: { handler: () => void }) => {
  return (
    <button
      className="bg-syfYellow h-[16px] w-[16px] rounded-full flex items-center justify-center mt-[6px] hover:bg-yellow-500"
      onClick={handler}
      aria-label="Close Summary"
    >
      <img
        src={closeButton}
        alt=""
        height={6}
        width={6}
        className="font-bold text-black"
      />
    </button>
  );
};

export default CloseButton;
